import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Box } from '@/components/lib'
import useStore from '../store'
import Login from './entry/Login'

export default function Home () {
  const navigate = useNavigate()
  const { user, loadingUser } = useStore()

  useEffect(() => {
    if (user) navigate('/trials')
  }, [user])

  return (
    <Box>
      {!user && !loadingUser &&
        <Login />}
    </Box>
  )
};
